export default __webpack_public_path__ + "static/media/Mm.461f3f2e.jfif";